<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="400px")
    v-card
      v-card-title.px-5.primary
        v-row(no-gutters)
          v-col
            p.mb-0.title.white--text {{ $t('verify_email_address') }}
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              v-icon(color="white" :size="24") mdi-close
      v-card-text.pa-0
        v-form.pa-4(ref="form")
          v-col.py-0.mt-4(cols="12")
            v-row
              v-col.grow.pr-0.py-0
                v-text-field(v-model="form.email" outlined dense disabled style="border-top-right-radius:0px; border-bottom-right-radius:0px")
              v-col.shrink.pl-0.py-0
                v-btn.white--text.body-2.primary(@click="changeEmail" height=40 depressed style="border-top-left-radius:0px; border-bottom-left-radius:0px; width: 96px") {{ $t('change') }}
          v-col.py-0.mb-n5.mt-n3(cols="12")
            v-row
              v-col.grow.pr-0(style="margin-right:-2px")
                v-text-field(v-model="form.code" outlined dense label="Confirmation code" :rules="rules.code" style="border-top-right-radius:0px; border-bottom-right-radius:0px")
              v-col.shrink.pl-0
                v-btn.white--text.body-2.primary(:disabled="codeTimer > 0" @click="requestCode" :loading="requestCodeLoading" height=40 depressed style="border-top-left-radius:0px; border-bottom-left-radius:0px;") {{ codeTimer <= 0 ? 'Request' : `Request (${codeTimer})` }}
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='grey' :loading="loading" text @click='closeModal')
            | {{ $t('cancel') }}
          v-btn.mr-2(color='accent' :loading="loading" depressed height=32 @click="verifyEmail")
            | {{ $t('verify') }}
      
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'VerifyEmail',
  props: ['showModal'],
  data: () => ({
    loading: false,
    requestCodeLoading: false,
    form: {
      email: '',
      code: '',
    },
    codeTimer: 0,
    rules: {
      code: [
        v => !!v || 'Confirmation code is required'
      ],
    }
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      lang: 'language/getLanguage'
    }),
  },
  mounted () {
    this.form.email = this.user.email
  },
  methods: {
    ...mapActions(['showMessage']),
    requestCode () {
      this.requestCodeLoading = true
      this.$axios.post('/users/send_verification_code/', { email: this.form.email, language: this.lang })
        .then(() => {
          this.showMessage(['success', `Confirmation code sent to ${this.form.email}`])
          this.codeTimer = 30
          const timer = setInterval(() => {
            this.codeTimer--
            if (this.codeTimer <= 0) {
              clearInterval(timer)
            }
          }, 1000)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_send_confirmation')])
        })
        .finally(() => {
          this.requestCodeLoading = false
        })
    },
    changeEmail () {
      this.$emit('changeEmail')
    },
    verifyEmail () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      this.$axios.patch(`/users/${this.user.id}/`, this.form)
          .then(resp => {
            this.$store.commit('user/setUser', resp.data)
            this.showMessage(['success', this.$t('success_message.email_successfully_verified')])
            this.closeModal()
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.invalid_confirmation_code')])
          })
          .finally(() => {
            this.loading = false
          })
    },
    closeModal () {
      this.$emit('update:showModal', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "verify_email_address": "Verify email address",
    "verify": "Verify"
  },
  "id": {
    "verify_email_address": "verifikasi email",
    "verify": "Verifikasi"
  }
}
</i18n>
